import Vue from 'vue'
import { v1 as uuidv1 } from 'uuid'

import MUTATION_TYPES from './mutation-types'
import CONSTANTS from './constants'

export default {
  [MUTATION_TYPES.SET_APP_CONFIG]: (state, config) => {
    state[CONSTANTS.APP_CONFIG] = config
  },
  [MUTATION_TYPES.SET_APP_CONSENT]: (state, consent) => {
    state[CONSTANTS.APP_CONSENT] = consent
  },
  [MUTATION_TYPES.SET_PAGE_NAVIGATION_ROUTE_TITLE]: (state, { name, title }) => {
    state[CONSTANTS.PAGE_TITLE][name] = title
  },
  [MUTATION_TYPES.SET_ROUTE_TITLE]: (state, title) => {
    state[CONSTANTS.ROUTE_TITLE] = title
  },
  [MUTATION_TYPES.SET_RETURN_ROUTE]: (state, route) => {
    state[CONSTANTS.RETURN_ROUTE] = route
  },
  [MUTATION_TYPES.SET_SCOPE]: (state, scope) => {
    state[CONSTANTS.SCOPE] = scope
  },
  [MUTATION_TYPES.SET_FILTER_DATA]: (state, { scope, ...rest }) => {
    Vue.set(state[CONSTANTS.FILTERS], scope, Object.freeze(rest))
  },
  [MUTATION_TYPES.CLEAR_FILTER_DATA]: (state, { scope }) => {
    Vue.set(state[CONSTANTS.FILTERS], scope, Object.freeze({}))
  },
  [MUTATION_TYPES.SET_APP_PENDING]: (state, pending) => {
    state[CONSTANTS.APP_PENDING] = pending
  },
  [MUTATION_TYPES.SET_APP_BAR_IS_HIDDEN]: (state, value) => {
    state[CONSTANTS.APP_BAR_IS_HIDDEN] = value
  },
  [MUTATION_TYPES.SET_LOGOUT_STATE]: (state, logout) => {
    state[CONSTANTS.LOGOUT_STATE] = logout
  },
  [MUTATION_TYPES.SET_CURRENT_LOGOUT_TIME]: (state, logout) => {
    state[CONSTANTS.CURRENT_LOGOUT_TIME] = logout
  },
  [MUTATION_TYPES.SET_OVERLAY_VISIBILITY]: (state, isVisible) => {
    state[CONSTANTS.OVERLAY_IS_VISIBLE] = isVisible
  },
  [MUTATION_TYPES.SET_BASKET_VISIBILITY]: (state, isVisible) => {
    state[CONSTANTS.BASKET_IS_VISIBLE] = isVisible
  },
  [MUTATION_TYPES.SET_NAVIGATION_DRAWER_VISIBILITY]: (state, isVisible) => {
    state[CONSTANTS.DRAWER_IS_VISIBLE] = isVisible
  },
  [MUTATION_TYPES.ADD_PORTAL_TARGET]: (state, value) => {
    if (!!value && !state[CONSTANTS.PORTAL_TARGETS].includes(value)) {
      state[CONSTANTS.PORTAL_TARGETS].push(value)
    }
  },
  // [MUTATION_TYPES.SET_SEARCH_DIALOG_VISIBILITY]: (state, isVisible) => {
  //   state[CONSTANTS.SEARCH_DIALOG_IS_VISIBLE] = isVisible
  // },
  // [MUTATION_TYPES.SET_SEARCH_QUERY]: (state, searchQuery = '') => {
  //   state[CONSTANTS.SEARCH_QUERY] = searchQuery
  // },
  // [MUTATION_TYPES.SET_SEARCH_SELECTION]: (state, selection) => {
  //   state[CONSTANTS.SEARCH_SELECTION] = selection
  // },
  // [MUTATION_TYPES.SET_SEARCH_PAGE]: (state, searchPage = 1) => {
  //   // ToDo: Remove
  //   state[CONSTANTS.SEARCH_PAGE] = parseInt(searchPage)
  // },
  // [MUTATION_TYPES.SET_SEARCH_OFFSET]: (state, offset = 0) => {
  //   state[CONSTANTS.SET_SEARCH_OFFSET] = parseInt(offset, 10)
  // },
  // [MUTATION_TYPES.SET_SEARCH_LIMIT]: (state, limit = 0) => {
  //   state[CONSTANTS.SET_SEARCH_LIMIT] = parseInt(limit, 10)
  // },
  // [MUTATION_TYPES.SET_SEARCH_URL]: (state, searchUrl = '') => {
  //   state[CONSTANTS.SEARCH_URL] = searchUrl
  // },
  // [MUTATION_TYPES.SET_SEARCH_QUERY_MIN_LENGTH]: (state, minLength) => {
  //   state[CONSTANTS.SEARCH_QUERY_MIN_LENGTH] = minLength
  // },
  [MUTATION_TYPES.SET_SEARCH_IMMEDIATE]: (state, immediate) => {
    state[CONSTANTS.SEARCH_IMMEDIATE] = immediate
  },
  // [MUTATION_TYPES.SET_SEARCH_IS_OVERVIEW]: (state, isOverview) => {
  //   state[CONSTANTS.SEARCH_IS_OVERVIEW] = isOverview
  // },
  // [MUTATION_TYPES.SET_SEARCH_PARAMS]: (state, params) => {
  //   // console.log('SET_SEARCH_PARAMS')
  //   // console.log(params)
  //   state[CONSTANTS.SEARCH_PARAMS] = { ...state[CONSTANTS.SEARCH_PARAMS], ...params }
  // },
  // [MUTATION_TYPES.SET_SEARCH_DIALOG_VISIBILITY]: (state, isVisible) => {
  //   state[CONSTANTS.SEARCH_DIALOG_IS_VISIBLE] = isVisible
  // },
  // [MUTATION_TYPES.ADD_CATEGORY]: (state, category) => {
  //   Vue.set(state[CONSTANTS.CATEGORIES], category.id, category)
  // },
  [MUTATION_TYPES.SET_PRODUCT_VIEW]: (state, productView) => {
    state[CONSTANTS.PRODUCT_VIEW] = productView
  },
  [MUTATION_TYPES.SET_DIMENSIONS]: (state, dimensions) => {
    Vue.set(state, CONSTANTS.DIMENSIONS, dimensions)
  },
  [MUTATION_TYPES.SET_SHOW_SCROLL_TO_TOP]: (state, value) => {
    state[CONSTANTS.SHOW_SCROLL_TO_TOP] = value
  },
  [MUTATION_TYPES.SET_LOCALE]: (state, code) => {
    state[CONSTANTS.LOCALE] = code
  },
  [MUTATION_TYPES.SET_HELP_PATH]: (state, path) => {
    state[CONSTANTS.HELP_PATH] = path
  },
  [MUTATION_TYPES.SET_RETURN_FROM_HELP]: (state, helpReturn) => {
    state[CONSTANTS.RETURN_FROM_HELP] = helpReturn
  },
  [MUTATION_TYPES.ADD_NOTIFICATION]: (state, notification) => {
    state[CONSTANTS.NOTIFICATIONS].push({ ...notification, id: uuidv1() })
  },
  [MUTATION_TYPES.REMOVE_NOTIFICATION_BY_ID]: (state, value) => {
    const ids = Array.isArray(value) ? value : [value]
    ids.forEach(id => {
      const index = state[CONSTANTS.NOTIFICATIONS].findIndex(i => i.id === id)
      if (index !== -1) {
        state[CONSTANTS.NOTIFICATIONS].splice(index, 1)
      }
    })
  },
  [MUTATION_TYPES.SET_NEWS_UNREAD]: (state, count) => {
    state[CONSTANTS.NEWS_UNREAD] = count
  },
  [MUTATION_TYPES.ADD_PAYMENT_TERMS]: (state, terms) => {
    state[CONSTANTS.PAYMENT_TERMS] = { ...state[CONSTANTS.PAYMENT_TERMS], ...terms }
  },
  [MUTATION_TYPES.SET_SELECTED_BRAND]: (state, brand) => {
    state[CONSTANTS.SELECTED_BRAND] = brand
  },
}
